import { useQuery } from "@apollo/client"
import { useId } from "@reach/auto-id"
import { useField, useFormikContext } from "formik"
import { gql } from "~/__generated__"
import { LabelWithClear } from "../ui/label-with-clear"
import { MultiSelect } from "../ui/multi-select"

const topicFieldQuery = gql(/* GraphQL */ `
  query TopicField {
    topics(first: 200) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)

export const TopicField = ({
  label,
  disabled,
  tooltip,
  ...props
}: {
  name: string
  label?: string
  disabled?: boolean
  id?: string
  tooltip?: string
}) => {
  const [field] = useField(props)
  const formik = useFormikContext()

  const filterResult = useQuery(topicFieldQuery, {})

  const filterData = filterResult.data

  const topics = filterData?.topics.edges.map((edge) => edge.node) ?? []

  const topicOptions =
    topics.map((topic) => ({
      label: topic.name,
      value: topic.id,
    })) ?? []

  const autoId = useId()
  const id = props.id ?? autoId

  return (
    <div>
      <LabelWithClear
        id={id}
        label={label}
        clearable={field.value.length > 0}
        onClear={() => formik.setFieldValue(field.name, [])}
        tooltip={tooltip}
      />
      <div>
        <MultiSelect
          id={id}
          name={field.name}
          options={topicOptions}
          selected={field.value}
          onValuesChange={(ids) => {
            formik.setFieldValue(field.name, ids)
          }}
          shouldFilter={true}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
